import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UnixTimeCode } from '../types/Utility';

export type parkingSpotState = {
    parkingSpots: Array<{
        label: string;
        last_used_at: UnixTimeCode;
    }>;
};

const initialState: parkingSpotState = { parkingSpots: [] };

const sortSpots = (a: { last_used_at: number }, b: { last_used_at: number }) => b.last_used_at - a.last_used_at;

const parkingSpotSlice = createSlice({
    name: 'parkingSpot',
    initialState,
    reducers: {
        addSpot: (state, action: PayloadAction<{ label: string }>) => {
            const foundSpot = state.parkingSpots.find((spot) => spot.label === action.payload.label);
            if (foundSpot) {
                foundSpot.last_used_at = new Date().getTime();
                return;
            }
            state.parkingSpots = [
                {
                    label: action.payload.label,
                    last_used_at: new Date().getTime(),
                },
                ...state.parkingSpots,
            ];

            state.parkingSpots.sort(sortSpots);
        },
    },
});

export const { addSpot } = parkingSpotSlice.actions;

export default parkingSpotSlice.reducer;
